"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logPrefix = void 0;
exports.logPrefix = 'Arc SDK';
//# sourceMappingURL=constants.js.map